/**
 * ExamplePromptButton - 例示プロンプトボタン
 * チャットおよび画像生成の例示プロンプト表示用の統一コンポーネント
 */

import { Button } from '@chakra-ui/react';

interface ExamplePromptButtonProps {
  text: string;
  onClick: () => void;
  disabled?: boolean;
}

export const ExamplePromptButton = ({
  text,
  onClick,
  disabled = false,
}: ExamplePromptButtonProps) => {
  return (
    <Button variant="secondary" size="sm" onClick={onClick} disabled={disabled} whiteSpace="nowrap">
      {text}
    </Button>
  );
};
